import fetchWithRetryBuilder, { type RequestInitWithRetry } from 'fetch-retry'
import qs from 'qs'

const fetchWithRetry = fetchWithRetryBuilder(fetch)

export const fetchStrapi = async <T extends { data: unknown }>(
  path: string,
  urlParamsObject = {},
  options = {},
): Promise<T> => {
  // Merge default and user options
  const mergedOptions: RequestInitWithRetry<typeof fetch> = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${process.env['CMS_TOKEN']}`,
    },
    ...options,
  }

  const queryString = qs.stringify(urlParamsObject)

  if (!process.env['CMS_HOST']) {
    return {} as T
  }

  const requestUrl = `${`${process.env['CMS_HOST']}/api${path}${queryString ? `?${queryString}` : ''}`}`

  const response = await fetchWithRetry(requestUrl, mergedOptions)

  if (!response.ok) {
    throw new Error(`An error occurred when fetching from ${requestUrl}: ${response.statusText}`)
  }

  const data = await response.json()
  return data as T
}
